export default {
  no_results: {
    title: 'Aucun résultat pour « {{search}} »',
    desc: 'Désolé, aucune correspondance trouvée. Veuillez essayer un autre terme de recherche.',
  },
  empty_menu: {
    title: "Aucun article disponible pour l'instant",
    desc: "Ce menu n'a rien à afficher pour le moment. Revenez bientôt.",
  },
};
